import styled, { css } from 'styled-components/macro';
import { hexToRGB } from '@repo-level/core-front';

import { device } from 'components/styles/MediaQuery';

export interface ScUserWalletsProps {
  isActive?: boolean;
  darkSelector?: boolean;
  menuMode?: boolean;
  isDisabledSelection?: boolean;
}

export const ScUserWallets = styled.div<ScUserWalletsProps>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 111;

  ${({ menuMode }) =>
    menuMode
      ? css`
          justify-content: space-between;
          gap: 8px;
          background: ${({ theme }) => theme.grayColor6};
          border-radius: 16px;
          padding: 12px;
        `
      : css`
          flex-direction: column;
          gap: 8px;
          border-radius: 12px;

          @media (${device.mobile}) {
            padding: 4px;
            flex-direction: row;
            height: 48px;
          }
        `}

  .select-wallet {
    display: flex;
    background: transparent;
    flex-direction: column;
    border-radius: 12px;
    transition: background-color 0.3s;
    margin-bottom: 0px;
    z-index: 2;

    ${({ menuMode }) =>
      menuMode
        ? css`
            & > .balance {
              font-weight: bold;
              font-weight: 700;
              font-size: 14px;
              line-height: 1.43;
            }
          `
        : css`
            width: 100%;
            padding: 4px;
          `}

    @media (${device.mobileXS}) {
      margin-right: 0;
    }

    .loader {
      font-weight: 700;
      font-size: 14px;
      line-height: 1.43;
      color: ${({ theme }) => theme.grayColor1};
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;

      svg {
        height: 100%;
        width: 26px;
        circle {
          fill: ${({ theme }) => theme.grayColor1};
        }
      }
    }

    .current-wallet {
      position: relative;
      cursor: ${({ isDisabledSelection }) =>
        isDisabledSelection ? 'default' : 'pointer'};
      background: transparent;
      white-space: nowrap;
      z-index: 11;
      width: 100%;
      border: none;
      color: ${({ theme }) => theme.grayColor1};
      font-weight: 700;
      padding: 4px 8px;

      ${({ menuMode }) =>
        menuMode
          ? css`
              font-size: 18px;
              line-height: 24px;
              display: flex;
              align-items: center;
              letter-spacing: 0.18px;
            `
          : css`
              border-radius: 8px;
              font-size: 14px;
              line-height: 20px;
              text-align: left;
              height: 28px;

              @media (${device.mobile}) {
                background: transparent !important;
                padding-left: 4px;
              }
            `}

      & > .wallet-value {
        position: relative;
        padding-right: 16px;
        width: 100%;
        max-width: 100%;
        display: flex;
        z-index: 1;

        & > p {
          max-width: 100%;
          color: ${({ theme }) => theme.whiteColor};
          margin-right: 4px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          .symbol {
            color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
          }
        }

        @media (${device.mobile}) {
          font-size: ${({ menuMode }) => (menuMode ? 'inherit' : '16px')};
          width: fit-content;

          & > p {
            max-width: none;
          }
        }
      }

      .arrow {
        position: absolute;
        top: 50%;
        right: 2px;
        translate: 0 -50%;
        rotate: 90deg;
        transition: rotate 0.3s;

        @media (${device.mobile}) {
          right: 0;
        }

        svg {
          width: 16px;
          height: 16px;
          object-fit: contain;
          vertical-align: middle;
        }
      }

      ${({ isDisabledSelection }) =>
        !isDisabledSelection &&
        css`
          @media (hover: hover) {
            &:hover {
              & > .wallet-value {
                & > p {
                  .symbol {
                    color: ${({ theme }) => theme.whiteColor};
                  }
                }
              }

              .arrow {
                svg path {
                  fill: ${({ theme }) => theme.whiteColor};
                }
              }
            }
          }
        `}
    }

    .options {
      transition: 0.3s;
      position: relative;
      padding-top: 4px;

      & > div {
        position: relative;
        padding: 0;
        background: transparent;
        width: 100%;
        transition: 0.3s;

        & > .content {
          padding: 0;
          background: transparent;

          .options-list {
            padding: 6px 8px 6px 0;
            box-shadow: none;

            &.no-scroll {
              padding: 0;
            }

            li {
              border-radius: 8px;
              font-size: 14px;
              line-height: 20px;
              transition: 0.3s;

              &:hover {
                background: ${({ theme }) => theme.grayColor5};
              }
            }
          }
        }
      }
    }
  }

  .dep-btn {
    height: 48px;
    padding: 0 16px;
    min-width: 140px;
  }

  ${({ darkSelector, theme }) =>
    darkSelector &&
    css`
      .select-wallet {
        background: ${theme.grayColor4};
      }
    `}

  ${({ isActive, theme }) =>
    isActive &&
    css`
      .select-wallet {
        background: ${theme.grayColor4};

        @media (${device.mobile}) {
          margin-bottom: 0;
          background: transparent;
        }

        .current-wallet .arrow {
          rotate: 270deg;
        }
      }
    `}
`;
